import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import { FileItem } from 'ng2-file-upload';
import { FileUploader } from 'ng2-file-upload';

import { Task } from 'src/app/model/sales/task.model';
import { Merchant } from 'src/app/model/sales/merchant.model';
import { UploadDialogComponent } from '../upload-dialog/upload-dialog.component';
import { InstallationService } from '../../../../../service/sales/installation.service';
import { UploadFile } from 'src/app/model/sales/upload-file.model';
import { AlertService } from '../../../../../service/alert.service';

@Component({
  selector: 'app-upload-page',
  templateUrl: './upload-page.component.html',
  styleUrls: ['./upload-page.component.scss']
})
export class UploadPageComponent implements OnInit {


  public uploader!: FileUploader;
  public hasBaseDropZoneOver?: boolean;
  public tasks!: Array<Task>;
  public installation!: Merchant;


  constructor(private activeRoute: ActivatedRoute,
              private dialog: MatDialog,
              private installationService: InstallationService,
              private alertService: AlertService) { }

  ngOnInit(): void {

    this.uploader = new FileUploader({
      disableMultipart: false, // 'DisableMultipart' must be 'true' for formatDataFunction to be called.
      formatDataFunctionIsAsync: true,
      formatDataFunction: async (item: any) => {
        return new Promise( (resolve, reject) => {
          resolve({
            name: item._file.name,
            length: item._file.size,
            contentType: item._file.type,
            date: new Date(),
          });
        });
      }
    });

    this.LoadTasks();

  }

  private LoadTasks(): void {
    this.tasks = new Array();

    let merchantId = 165;//temporary

    this.activeRoute.queryParams.subscribe((params) => {
      console.log('SUCCESS TOKEN', params['token']);
      this.installationService
          .docs(params['token'])
          .subscribe((file: UploadFile | any)=>{
            console.log('SUCCESS', file);

            let uploadFile = new UploadFile().load(file);

            uploadFile.tasks!.forEach((task)=>{
              this.tasks.push(new Task().load(task));
            });

          }, err => {
            this.alertService
                .error(err.message, err);
            console.log('ERROR', err);
          }
      );
    });

  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public deleteFile(file: FileItem): void {
    this.uploader.removeFromQueue(file);
  }

  public openUpload(task: Task | any,
                    type: string,
                    merchant: Merchant): void {

    const data: any = {type: type,
                       task: task,
                       merchant: merchant};

    const dialog = this.dialog
                       .open(UploadDialogComponent,
                              {data: data,
                               width: "400px",
                               maxHeight: "100vh"});

    dialog.afterClosed()
          .subscribe((result: FileUploader | any) => {

      if (result) {
        if (type.includes('upload')) {
          this.uploader = result;
          this.uploadFile(merchant,
                          task);
        }
      }
    });
  }

  private uploadFile(installation: Merchant, task: Task): void {
    if (this.uploader.queue.length > 0) {

      let upstream: FileItem | any;
      let blob;
      let file = this.uploader.queue[0].file;

      console.log('FILE', file.name);

      blob = new Blob([JSON.stringify(file)], {type: file.type})
      let stream = blob.stream();
      let arrayBuffer = blob.arrayBuffer();

      arrayBuffer.then((value)=>{
        console.log('ARRAYBUFFER VALUE',value);
      })

      let reader = stream.getReader();

      reader.read().then( ({done, value}) => {
        // If there is no more data to read
        if (done) {
          return;
        }
        // Get the data and send it to the browser via the controller
        // controller.enqueue(value);
        // Check chunks by logging to the console
        upstream = value;
        console.log('UPSTREAM', upstream);

        this.installationService
            .uploadByMerchant(installation.id,
                              task,
                              file,
                              upstream)
            .subscribe((response) => {

              console.log('FILE', this.uploader.queue[0].file?.name);

              this.uploader
                  .removeFromQueue(this.uploader.queue[0]);
              this.uploadFile(installation, task);

          }, error => {
            this.alertService
                .error(error.message, error);
            console.log('ERROR', error);
        });

      });
    }
  }
}
